import { AlertOctagon } from "lucide-react";
import { useFormState } from "react-hook-form";

export default function FormError(): React.ReactElement | null {
  const { errors } = useFormState();
  const serverError = errors.root?.server;

  if (!serverError) return null;

  return (
    <div
      className="relative flex items-center justify-center gap-2 text-red"
      data-testid="FormError"
    >
      <AlertOctagon className="h-4 w-4" />
      <div className="grid gap-1">
        <span className="text-body1 text-red">{serverError.message}</span>
      </div>
    </div>
  );
}
